import Script from 'next/script';
import randomise from 'randomatic';
import React, { useEffect, useState } from 'react';

import { Meta } from '@/layouts/Meta';
import { initializeStore } from '@/models/root-store';
import type { SeoData } from '@/shared/types';
import { Main } from '@/templates/Main';
import { getGeneralPageSeoData, getUIContentData } from '@/utils/api-helpers';

type StockistsProps = {
  seoData: SeoData;
  content: Record<string, any>;
};

const Stockists: React.FC<StockistsProps> = ({
  seoData,
  content,
}: StockistsProps) => {
  const [scriptId, setScriptId] = useState('');
  useEffect(() => {
    setScriptId(randomise('A0'));
  }, []);
  return (
    <Main
      meta={
        <Meta
          title={seoData?.seoTitle || 'Stockists'}
          description={seoData?.seoDescription || 'Stockists'}
          canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/stockists`}
        />
      }
      seoBlurb={seoData?.seoBlurb}
    >
      <div className="container px-4 font-inter lg:max-w-[75%]">
        <section className="mb-4 mt-12">
          <h1 className="mb-2 text-center font-interMedium text-[36px] leading-normal lg:text-left">
            {content?.heading}
          </h1>
          <p className="font-interMedium">{content?.description}</p>
        </section>

        <section className="my-4">
          <div id="storemapper" className="flex w-full justify-center">
            <p>
              {`Store Locator is loading from <a href="https://www.storemapper.co">
                Storemapper store locator software
              </a>
              ...`}
            </p>
          </div>
          {scriptId !== '' && (
            <Script
              id={`storeMapper${scriptId}`}
              strategy="afterInteractive"
              data-storemapper-start="2018,11,26"
              data-storemapper-id="4172"
              src={`https://www.storemapper.co/js/widget.js?${scriptId}`}
            ></Script>
          )}
        </section>
      </div>
    </Main>
  );
};

export async function getStaticProps() {
  const store = initializeStore({ ssr: true });
  const seoData: SeoData = await getGeneralPageSeoData(store, 'stockists');
  const content = await getUIContentData(store, 'stockists');

  return {
    props: {
      seoData,
      content,
    },
  };
}

export default Stockists;
